import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ReportUsersSummaryTableBody from './ReportUsersSummaryTableBody';
import type { UserIncomeReportRowType } from '@econtractor/types';

interface ReportUsersSummaryTableProps {
    users: UserIncomeReportRowType[];
}

const ReportUsersSummaryTable = ({ users }: ReportUsersSummaryTableProps) => {
    const { t } = useTranslation(['Reports']);

    return (
        <div className="crm-table-wrap">
            <Table className="ObjectRepTable table-hover">
                <thead>
                    <tr className="bg-light">
                        <td className="head-name">{t('usersFields.user')}</td>
                        <td className="text-end head-income">{t('usersFields.income')}</td>
                    </tr>
                </thead>
                <ReportUsersSummaryTableBody users={users} />
            </Table>
        </div>
    );
};

export default ReportUsersSummaryTable;
